import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CommentButtonProps {
  commentCount: number;
  onClick: () => void;
  size?: 'sm' | 'default';
}

export function CommentButton({ 
  commentCount, 
  onClick,
  size = 'sm'
}: CommentButtonProps) {
  return (
    <Button
      variant="ghost"
      size={size}
      onClick={onClick}
      className="flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors"
    >
      <MessageCircle className="w-4 h-4" />
      {commentCount > 0 && (
        <span className="text-sm font-medium">
          {commentCount}
        </span>
      )}
    </Button>
  );
}